import { updates } from "@/mocks/home";

export default function UpdateLog() {
  return (
    <section id="updates" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs tracking-[0.2em] text-primary-700 uppercase">Changelog</p>
            <h4 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              <a href="#updates" className="cursor-pointer hover:text-primary-700 transition-colors">
                入口更新日志
              </a>
            </h4>
            <p className="mt-3 text-sm text-foreground-600 max-w-2xl leading-relaxed">
              新增、失效、恢复和线路调整都会记在这里。打不开站时先扫一眼日志，多半能找到答案。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 self-start px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs border border-accent-200 whitespace-nowrap">
            <i className="ri-live-line"></i>
            每日两次自动巡检
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <ol className="lg:col-span-8 relative border-l border-background-300 pl-6 space-y-6">
            {updates.map((u) => (
              <li key={u.id} className="relative">
                <span className="absolute -left-[31px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></span>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="px-2 py-0.5 rounded-md text-[11px] bg-secondary-100 text-secondary-900 border border-secondary-200">
                    {u.tag}
                  </span>
                  <time className="text-[12px] text-foreground-500">{u.date}</time>
                </div>
                <h5 className="mt-2 text-[15px] font-medium text-foreground-950">{u.title}</h5>
                <p className="mt-1 text-[13px] text-foreground-600 leading-relaxed">{u.summary}</p>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4 flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h5 className="font-heading text-base text-foreground-950 flex items-center gap-2">
                <i className="ri-alarm-warning-line text-accent-600"></i>
                状态提醒
              </h5>
              <ul className="mt-4 space-y-3 text-[13px] text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-error-warning-line text-accent-600 mt-0.5"></i>
                  北美线路维护中，请暂用其他入口。
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-shield-check-line text-primary-600 mt-0.5"></i>
                  主域 HTTPS 证书已续期，可放心收藏。
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-add-circle-line text-primary-600 mt-0.5"></i>
                  新加坡镜像已上线，海外访问更稳。
                </li>
              </ul>
            </div>
            <div className="rounded-lg border border-background-200 bg-foreground-950 p-5 text-background-50">
              <h5 className="font-heading text-base">别等失效才找</h5>
              <p className="mt-2 text-[13px] text-background-200 leading-relaxed">
                现在就花 1 分钟，把本页和入口速览一起收进书签夹，之后无论域名怎么变，都能从这里找回来。
              </p>
              <a
                href="#guide"
                className="mt-4 inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-[13px] whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
              >
                <i className="ri-bookmark-3-line"></i>
                查看防走失指引
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}